import { IAttribute, IModel, IValidationContext, IViolation } from './../base/annotation';
import { Metamodel } from '../base/model';
import { LinkedService } from './linkedservice';
import { AzureKeyVault } from './key-vault';
import { format } from '../../shared/utils/string.util';
import { IPrivateEndpointCompatible } from '../../interfaces/IPrivateEndpointCompatible';
import { ModelConstants } from '../model-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { azureCloudTypeDef } from '../../constants/linkedservice-constants';
import { Credential } from '../credential/credential';
import { azureDefaultAuthRefTypes, azureBlobFSAuthTypes } from '../../interfaces/IAuthenticationType';

type AKVValidator = (linkedservice: LinkedService, referencedResource: AzureKeyVault, violation?: IViolation, context?: IValidationContext) => Promise<IViolation[] | undefined>;

export interface IAzureBlobLinkedServiceValidators {
    validateAKVLinkedserviceReference: AKVValidator;
}

export const azureBlobFSLinkedServiceValidators: IAzureBlobLinkedServiceValidators = {
    validateAKVLinkedserviceReference: undefined
};

@Metamodel.model({
    name: ModelConstants.adlsGen2LinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.AzureBlobFS_DisplayText),
        format(shellStringResources.ModelName_LinkedServicesTemplate, shellStringResources.AzureBlobFS_DisplayText)
    ]
})
export class AzureBlobFSLinkedService extends LinkedService implements IPrivateEndpointCompatible {
    public static readonly MODEL: IModel;
    public static readonly URL: IAttribute;
    public static readonly TENANT: IAttribute;
    public static readonly SERVICE_PRINCIPAL_ID: IAttribute;
    public static readonly SERVICE_PRINCIPAL_KEY: IAttribute;
    public static readonly ACCOUNT_KEY: IAttribute;
    public static readonly SAS_URI: IAttribute;
    public static readonly SAS_TOKEN: IAttribute;

    public isOldServicePrincipalResource: boolean = false;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Url,
        association: 'URL',
        templatable: true
    })
    public url?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_StorageAccountKey,
        association: 'ACCOUNT_KEY',
        templatable: true,
        accepts: ['String'],
        constraint: {
            validator: (linkedservice: LinkedService, referencedResource: AzureKeyVault, violation?: IViolation, context?: IValidationContext): Promise<IViolation[] | undefined> => {
                if (azureBlobFSLinkedServiceValidators.validateAKVLinkedserviceReference) {
                    return azureBlobFSLinkedServiceValidators.validateAKVLinkedserviceReference(linkedservice, referencedResource, violation, context);
                }
                return undefined;
            }
        }
    })
    public accountKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Tenant,
        association: 'TENANT',
        templatable: true
    })
    public tenant: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ServicePrincipalID,
        association: 'SERVICE_PRINCIPAL_ID',
        templatable: true
    })
    public servicePrincipalId: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ServicePrincipalKey,
        association: 'SERVICE_PRINCIPAL_KEY',
        templatable: true,
        accepts: ['String'],
        constraint: {
            validator: (linkedservice: LinkedService, referencedResource: AzureKeyVault, violation?: IViolation, context?: IValidationContext): Promise<IViolation[] | undefined> => {
                if (azureBlobFSLinkedServiceValidators.validateAKVLinkedserviceReference) {
                    return azureBlobFSLinkedServiceValidators.validateAKVLinkedserviceReference(linkedservice, referencedResource, violation, context);
                }
                return undefined;
            }
        }
    })
    public servicePrincipalKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ServicePrincipalCredentialType
    })
    public servicePrincipalCredentialType?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ServicePrincipalCert,
        constraint: {
            validator: (linkedservice: LinkedService, referencedResource: AzureKeyVault, violation?: IViolation, context?: IValidationContext): Promise<IViolation[] | undefined> => {
                if (azureBlobFSLinkedServiceValidators.validateAKVLinkedserviceReference) {
                    return azureBlobFSLinkedServiceValidators.validateAKVLinkedserviceReference(linkedservice, referencedResource, violation, context);
                }
                return undefined;
            }
        }
    })
    public servicePrincipalCert?: AzureKeyVault;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_AzureCloudType
    })
    public azureCloudType?: azureCloudTypeDef;

    @Metamodel.attribute({
        display: shellStringResources.Credential,
        reference: true,
        constraint: {
            validator: (linkedservice: LinkedService, referencedResource: AzureKeyVault, violation?: IViolation, context?: IValidationContext): Promise<IViolation[] | undefined> => {
                if (azureBlobFSLinkedServiceValidators.validateAKVLinkedserviceReference) {
                    return azureBlobFSLinkedServiceValidators.validateAKVLinkedserviceReference(linkedservice, referencedResource, violation, context);
                }
                return undefined;
            }
        }
    })
    public credential?: Credential;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_SasURI,
        association: 'SAS_URI',
        templatable: true
    })
    public sasUri?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_SasURI,
        constraint: {
            validator: (linkedservice: LinkedService, referencedResource: AzureKeyVault, violation?: IViolation, context?: IValidationContext): Promise<IViolation[] | undefined> => {
                if (azureBlobFSLinkedServiceValidators.validateAKVLinkedserviceReference) {
                    return azureBlobFSLinkedServiceValidators.validateAKVLinkedserviceReference(linkedservice, referencedResource, violation, context);
                }
                return undefined;
            }
        }
    })
    public referedSasUriAKV?: AzureKeyVault;

    public enableSasUriAKV?: boolean = false;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_SasToken,
        association: 'SAS_TOKEN',
        templatable: true,
        accepts: ['String'],
        constraint: {
            validator: (linkedservice: LinkedService, referencedResource: AzureKeyVault, violation?: IViolation, context?: IValidationContext): Promise<IViolation[] | undefined> => {
                if (azureBlobFSLinkedServiceValidators.validateAKVLinkedserviceReference) {
                    return azureBlobFSLinkedServiceValidators.validateAKVLinkedserviceReference(linkedservice, referencedResource, violation, context);
                }
                return undefined;
            }
        }
    })
    public sasToken?: string | AzureKeyVault;

    public authenticationMethod?: string = azureBlobFSAuthTypes.AccountKeyAuthentication;

    public authReferenceMethod?: string = azureDefaultAuthRefTypes.InlineRefTypeAuthentication;

    protected _accountResourceID?: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public getPEResourceIDAndName(): { id: string, name: string } {
        const resourceName = this._getPEResourceName();
        if (!resourceName || this._accountResourceID && !this._accountResourceID.endsWith('/' + resourceName)) {
            this._accountResourceID = undefined;
        }
        return {
            id: this._accountResourceID,
            name: resourceName
        };
    }

    public setPEResourceID(id: string): void {
        this._accountResourceID = id;
    }

    public reset(): void {
        this.isOldServicePrincipalResource = false;
        this.accountKey = undefined;
        this.servicePrincipalId = undefined;
        this.servicePrincipalKey = undefined;
        this.servicePrincipalCredentialType = undefined;
        this.servicePrincipalCert = undefined;
        this.azureCloudType = undefined;
        this.credential = undefined;
        this.tenant = undefined;
        this.sasUri = undefined;
        this.sasToken = undefined;
        this.referedSasUriAKV = undefined;
    }

    protected _getPEResourceName(): string {
        switch (this.authenticationMethod) {
            case azureBlobFSAuthTypes.AccountKeyAuthentication:
            case azureBlobFSAuthTypes.MSIAuthentication:
            case azureBlobFSAuthTypes.ServicePrincipalAuthentication:
            case azureBlobFSAuthTypes.Credential:
            case azureBlobFSAuthTypes.UserAssignedManagedIdentity:
                if (this.url?.toLowerCase().startsWith('https://')) {
                    return this.url.substr(8).split('.')[0];
                }
                return '';
            case azureBlobFSAuthTypes.SasUriAuthentication:
                if (this.sasUri?.toLowerCase().startsWith('https://')) {
                    return this.sasUri.substr(8).split('.')[0];
                }
                return '';
            default:
                return '';
        }
    }
}
